import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _mergeProps({
    role: "button",
    href: _ctx.href,
    disabled: _ctx.isDisabled,
    class: _ctx.linkClasses
  }, _ctx.$attrs, {
    onClick: _withModifiers(_ctx.page.click, ["prevent"]),
    "aria-label": _ctx.page['aria-label'],
    "aria-current": _ctx.page.isCurrent
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.page.number), 1)
      ])
    ]),
    _: 3
  }, 16, ["href", "disabled", "class", "onClick", "aria-label", "aria-current"]))
}